<template>
     <div class="align-items-center d-flex h-100 justify-content-center position-absolute w-100">
          <div
               class="align-items-center bg-dark bg-opacity-50 d-flex fixed-top h-100 justify-content-center w-100"
               v-if="isLoading"
          >
               <PulseLoader />
          </div>
          <div class="col-10 col-lg-5 col-md-7 col-xl-3 fadeInDown p-0 py-5 rounded-3 shadow-lg">
               <header class="my-4">
                    <img
                         alt="Logo"
                         class="fadeIn first w-50"
                         src="assets/logo.png"
                    />
                    <div class="mt-4 px-4">
                         <h6 class="align-items-center d-flex fadeIn second fw-semibold justify-content-center m-0 text-center">
                              <svg
                                   height="16"
                                   viewBox="0 0 512 512"
                              >
                                   <path d="M256 0c14.7 0 28.2 8.1 35.2 21l216 400c6.7 12.4 6.4 27.4-.8 39.5S486.1 480 472 480L40 480c-14.1 0-27.2-7.4-34.4-19.5s-7.5-27.1-.8-39.5l216-400c7-12.9 20.5-21 35.2-21zm0 352a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-192c-18.2 0-32.7 15.5-31.4 33.7l7.4 104c.9 12.5 11.4 22.3 23.9 22.3 12.6 0 23-9.7 23.9-22.3l7.4-104c1.3-18.2-13.1-33.7-31.4-33.7z" />
                              </svg>
                              <span class="ms-2">
                                   Redefini&ccedil;&atilde;o de senha
                              </span>
                         </h6>
                         <p class="fadeIn third m-0 small">
                              Ao continuar, um c&oacute;digo de recupera&ccedil;&atilde;o ser&aacute; enviado para o e-mail cadastrado
                         </p>
                    </div>
               </header>
               <form
                    class="px-4"
                    method="post"

                    @submit.prevent="requestChange"
               >
                    <input
                         class="border border-2 fadeIn fourth mb-2 p-3 rounded-2 text-center w-100"
                         maxlength="11"
                         placeholder="CPF"
                         required="true"
                         type="text"
                         v-model="cpf"

                         @input="handleCpf"
                    />
                    <input
                         class="border-0 fadeIn fifth mb-3 p-3 rounded-2 text-uppercase text-white"
                         type="submit"
                         value="Continuar"
                    />
               </form>
               <div class="fadeIn sixth mt-3">
                    <small>
                         {{ this.$version }}
                    </small>
               </div>
          </div>
     </div>
</template>
<script>
     import PulseLoader from 'vue-spinner/src/PulseLoader.vue';


     export default {
          name: "PasswordChangeRequestCmp",
          components: {
               PulseLoader
          },
          data() {
               return {
                    isLoading: false,
                    cpf      : ""
               };
          },
          methods: {
               async requestChange() {
                    try {
                         this.isLoading = true;
                         const endpoint = "v2/senha/recuperacao/solicitar";
                         
                         await axios.post(endpoint, {
                              CPF: this.cpf
                         });

                         this.$router.push("/password/change?cpf=" + this.cpf);
                    } catch (error) {
                         const response = error.response;
                         const message  = response
                              ? response.data.message
                              : "Servidor inacessível";

                         this.$notify({
                              group: "alerts",
                              text : message,
                              title: "Atenção!",
                              type : "error"
                         });
                    } finally {
                         this.isLoading = false;
                    }
               },
               handleCpf(e) {
                    this.cpf = e.target.value
                         .replace(/\D/g, "");
               }
          }
     };
</script>